import React, { useState, useEffect, Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "../Button"
import ReactTable from "react-table";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import * as constants from "../../../constants";
import fetch from "../../util/api-ajax";

const EditEmail = ({ openDialog, setOpenDialog, getBlacklistedEmails, blacklisted }) => {
  const [email, setEmail] = useState("")
  const [disable, setDisable] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const handleEditEmail = async data => {
    setDisable(true)
    await fetch(constants.BLACKLISTED_EMAILS_UPDATE_EMAIL, data)
      .then(async (res) => {
        if (res.error) {
          setErrorMessage(res.error)
        } else {
          setOpenDialog(false)
          cleanForm()
          await getBlacklistedEmails()
        }
      })
      .catch((error) => {
        setErrorMessage(error.message)
      })
      .finally(() => {
        setDisable(false)
      });
  }

  const cleanForm = () => {
    setEmail("")
  }

  useEffect(() => {
    cleanForm()
    if (blacklisted && blacklisted.email) {
      setEmail(blacklisted.email)
    }
  }, [blacklisted])

  return (
    <Dialog
      open={openDialog}
      ariaHideApp={false}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle>
        Edit Blacklisted Email
      </DialogTitle>
      <DialogContent style={{ overflow: "hidden" }}>
        <DialogContentText>
          <Grid container>
            <Grid item sm={12} style={{ marginTop: "20px" }}>
              <TextField
                label="Email"
                type="email"
                size="small"
                color="primary"
                width="100%"
                value={email}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "100%" }}
                variant="outlined"
              />
            </Grid>
            {
              errorMessage &&
              <Grid item sm={12} style={{ marginTop: "20px" }}>
                <div style={{ color: "red" }}>{errorMessage}</div>
              </Grid>
            }
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={async () => {
            await handleEditEmail({
              "email": email,
              "id": blacklisted.id
            })
          }}
          color="secondary"
          variant="contained"
          style={{
            float: "right",
            marginBottom: 10,
          }}
          disabled={!email || disable}
        >
          Edit
        </Button>
        <Button
          onClick={async () => {
            cleanForm()
            setOpenDialog(false)
          }}
          color="primary"
          variant="contained"
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const RemoveEmail = ({ openDialog, setOpenDialog, blacklisted, getBlacklistedEmails }) => {
  const [disable, setDisable] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const handleResetPassword = async data => {
    setDisable(true)
    await fetch(constants.BLACKLISTED_EMAILS_DELETE_EMAIL, data)
      .then(async (res) => {
        if (res.error) {
          setErrorMessage(res.error)
        } else {
          setOpenDialog(false)
          await getBlacklistedEmails()
        }
      })
      .catch((error) => {
        setErrorMessage(error.message)
      })
      .finally(() => {
        setDisable(false)
      });
  }

  return (
    <Dialog
      open={openDialog}
      ariaHideApp={false}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle>
        Remove Blacklisted Email
      </DialogTitle>
      <DialogContent style={{ overflow: "hidden" }}>
        <DialogContentText>
          <Grid container>
            <Grid item sm={12} style={{
              color: "black",
              textAlign: "center"
            }}>
              Are you sure you want to remove the blacklisted email?
            </Grid>
            {
              errorMessage &&
              <Grid item sm={12} style={{ marginTop: "20px" }}>
                <div style={{ color: "red" }}>{errorMessage}</div>
              </Grid>
            }
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={async () => {
            await handleResetPassword({
              "id": blacklisted.id,
            })
          }}
          color="secondary"
          variant="contained"
          style={{
            float: "right",
            marginBottom: 10,
          }}
          disabled={disable}
        >
          Confirm
        </Button>
        <Button
          onClick={async () => { setOpenDialog(false) }}
          color="primary"
          variant="contained"
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const CreateEmail = ({ openDialog, setOpenDialog, getBlacklistedEmails }) => {
  const [email, setEmail] = useState("")
  const [disable, setDisable] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const handleCreateEmail = async data => {
    setDisable(true)
    await fetch(constants.BLACKLISTED_EMAILS_CREATE_EMAIL, data)
      .then(async (res) => {
        if (res.error) {
          setErrorMessage(res.error)
        } else {
          setOpenDialog(false)
          cleanForm()
          await getBlacklistedEmails()
        }
      })
      .catch((error) => {
        setErrorMessage(error.message)
      })
      .finally(() => {
        setDisable(false)
      });
  }

  const cleanForm = () => {
    setEmail("")
  }

  useEffect(() => {
    cleanForm()
  }, [])

  return (
    <Dialog
      open={openDialog}
      ariaHideApp={false}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle>
        Create Blacklisted Email
      </DialogTitle>
      <DialogContent style={{ overflow: "hidden" }}>
        <DialogContentText>
          <Grid container>
            <Grid item sm={12} style={{ marginTop: "20px" }}>
              <TextField
                label="Email"
                type="email"
                size="small"
                color="primary"
                width="100%"
                value={email}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "100%" }}
                variant="outlined"
              />
            </Grid>
            {
              errorMessage &&
              <Grid item sm={12} style={{ marginTop: "20px" }}>
                <div style={{ color: "red" }}>{errorMessage}</div>
              </Grid>
            }
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={async () => {
            await handleCreateEmail({
              "email": email,
            })
          }}
          color="secondary"
          variant="contained"
          style={{
            float: "right",
            marginBottom: 10,
          }}
          disabled={!email || disable}
        >
          Create
        </Button>
        <Button
          onClick={async () => {
            cleanForm()
            setOpenDialog(false)
          }}
          color="primary"
          variant="contained"
          style={{
            float: "right",
            marginRight: 20,
            marginBottom: 10,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const EmailBlacklist = props => {
  const {
    emails,
    doFetchGetEmails,
  } = props
  const [selectedEmail, setSelectedEmail] = useState({});
  const [createUserDialog, setCreateEmailDialog] = useState(false);
  const [editUserDialog, setEditEmailDialog] = useState(false);
  const [removeUserDialog, setDeleteEmailDialog] = useState(false);

  const handleFetchEmails = async () => {
    await doFetchGetEmails();
  }

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      Cell: ({ value }) => (<div style={{ textAlign: "center" }}>{value}</div>)
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ value }) => (<div style={{ textAlign: "center" }}>{value}</div>)
    },
    {
      Header: "Created At",
      accessor: "created",
      Cell: ({ value }) => (<div style={{ textAlign: "center" }}>{value}</div>)
    },
        {
      Header: "Modified At",
      accessor: "modified",
      Cell: ({ value }) => (<div style={{ textAlign: "center" }}>{value}</div>)
    },
    {
      Header: "",
      accessor: "id",
      Cell: (row) => (
        <div style={{ textAlign: "center" }}>
          <Button
            style={{
              maxWidth: "30px",
              maxHeight: "30px",
              minWidth: "15px",
              minHeight: "15px",
              marginRight: "10px",
            }}
            onClick={async () => {
              await setSelectedEmail(row.original);
              await setEditEmailDialog(true);
            }}
            variant="contained"
            color="primary"
            size="small"
            title="Edit email"
          >
            <EditIcon />
          </Button>
          <Button
            style={{
              maxWidth: "30px",
              maxHeight: "30px",
              minWidth: "15px",
              minHeight: "15px",
            }}
            onClick={async () => {
              await setSelectedEmail(row.original);
              await setDeleteEmailDialog(true);
            }}
            variant="contained"
            color="secondary"
            size="small"
            title="Remove email"
          >
            <CloseIcon />
          </Button>
        </div>
      )
    }
  ]

  useEffect(() => {
    handleFetchEmails()
  }, [])

  return (
    <div>
      <Grid container>
        <Grid item sm={6}>
          <h4>Blacklisted Emails</h4>
        </Grid>
        <Grid item sm={6}>
          <Button
            onClick={async () => {
              await setCreateEmailDialog(true)
            }}
            color="secondary"
            variant="contained"
            style={{ float: "right", margin: "24px 0 16px"}}
          >
            Add blacklisted email
          </Button>
        </Grid>
      </Grid>
      <CreateEmail
        openDialog={createUserDialog}
        setOpenDialog={setCreateEmailDialog}
        getBlacklistedEmails={doFetchGetEmails}
      />
      <EditEmail
        openDialog={editUserDialog}
        setOpenDialog={setEditEmailDialog}
        blacklisted={selectedEmail}
        getBlacklistedEmails={handleFetchEmails}
      />
      <RemoveEmail
        openDialog={removeUserDialog}
        setOpenDialog={setDeleteEmailDialog}
        blacklisted={selectedEmail}
        getBlacklistedEmails={doFetchGetEmails}
      />
      <br />
      {
        emails && emails.length > 0 ?
          <Fragment>
            <ReactTable
              data={emails.sort((a, b) => a.id - b.id)}
              columns={columns}
              className="-striped -highlight"
              defaultPageSize={10}
              defaultSortDesc
              filterable
            />
          </Fragment> :
          <div>
            There are no users to show
          </div>
      }
    </div>
  )
}

export default EmailBlacklist